export default "__VITE_PUBLIC_ASSET__7db9772b__"